import React from 'react';
import {useTranslation} from 'react-i18next';

import {Typography} from '@nur-portal/ui-kit';

import Loader from '../../../modules/auth/components/ui/loader';
import {getFormattedDate} from '../../utils/date';
import {ShareMenu} from '../share-menu';

import styles from './trend-body.module.css';

const TrendBody = ({trend}) => {
  const {t, i18n} = useTranslation();

  const isDesktop = window.Site?.targeting.platform === 'desktop';

  if (!trend) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <a
        className={styles.label}
        href='/trends'
      >
        {t('trend')}
      </a>
      <Typography
        variantMapping={{
          mobile: 'title-28',
          desktop: 'title-42'
        }}
        className={styles.title}
      >
        {trend?.[0].title}
      </Typography>
      <Typography
        variantMapping={{
          mobile: 'title-28',
          desktop: 'title-42'
        }}
        className={styles.subTitle}
      >
        {trend?.[0].subTitle}
      </Typography>
      <div className={styles.shareWrapper}>
        <div className={styles.datesWrapper}>
          <Typography variant="text-14" className={styles.datePublished}>
            <span className={styles.dateLabel}>{t('published')}:</span>
            <time dateTime={new Date(trend?.[0].publishedAt).toISOString()}>
              {getFormattedDate(trend?.[0].publishedAt, i18n.language)}
            </time>
          </Typography>
          <Typography variant="text-14" className={styles.dateUpdated}>
            <span className={styles.dateLabel}>{t('lastUpdate')}:</span>
            <time dateTime={new Date(trend?.[0].updatedAt).toISOString()}>
              {getFormattedDate(trend?.[0].updatedAt, i18n.language)}
            </time>
          </Typography>
        </div>
        {isDesktop && (
          <ShareMenu
            title={trend?.[0].title}
            utmMedium="trend-share"
            url={`${window.location.origin}${window.location.pathname}`}
          />
        )}
      </div>
    </div>
  );
};

export default TrendBody;
